import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_5a690f01 from 'nuxt_plugin_sentryserver_5a690f01' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_16a0c50e from 'nuxt_plugin_sentryclient_16a0c50e' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_599beea7 from 'nuxt_plugin_plugin_599beea7' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_688061e5 from 'nuxt_plugin_cookieuniversalnuxt_688061e5' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_3b3696b6 from 'nuxt_plugin_vuesocialsharingplugin_3b3696b6' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_nuxtsocketio_76847fc5 from 'nuxt_plugin_nuxtsocketio_76847fc5' // Source: ./nuxt-socket-io.js (mode: 'all')
import nuxt_plugin_nuxtizitoastpluginbd4a3472_e22c11bc from 'nuxt_plugin_nuxtizitoastpluginbd4a3472_e22c11bc' // Source: ./nuxt-izitoast.plugin.bd4a3472.js (mode: 'all')
import nuxt_plugin_recaptcha_0dc1f7a8 from 'nuxt_plugin_recaptcha_0dc1f7a8' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_gtm_514ce35a from 'nuxt_plugin_gtm_514ce35a' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_6f764786 from 'nuxt_plugin_axios_6f764786' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_4c4f3619 from 'nuxt_plugin_workbox_4c4f3619' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_38c1542c from 'nuxt_plugin_metaplugin_38c1542c' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_3d68f9a0 from 'nuxt_plugin_iconplugin_3d68f9a0' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_http_493e3a73 from 'nuxt_plugin_http_493e3a73' // Source: ./http.js (mode: 'all')
import nuxt_plugin_bothsides_3b0578a6 from 'nuxt_plugin_bothsides_3b0578a6' // Source: ../plugins/both-sides (mode: 'all')
import nuxt_plugin_clientonly_98019990 from 'nuxt_plugin_clientonly_98019990' // Source: ../plugins/client-only (mode: 'client')
import nuxt_plugin_index_6c6ccc7d from 'nuxt_plugin_index_6c6ccc7d' // Source: ../plugins/directives/index (mode: 'all')
import nuxt_plugin_index_77bd1e08 from 'nuxt_plugin_index_77bd1e08' // Source: ../plugins/filters/index (mode: 'all')
import nuxt_plugin_index_64d6d112 from 'nuxt_plugin_index_64d6d112' // Source: ../plugins/helpers/index (mode: 'all')
import nuxt_plugin_gtag_c19af404 from 'nuxt_plugin_gtag_c19af404' // Source: ../plugins/libs/gtag (mode: 'all')
import nuxt_plugin_axios_46cb9dab from 'nuxt_plugin_axios_46cb9dab' // Source: ../plugins/libs/axios (mode: 'all')
import nuxt_plugin_unsplash_b291ee2a from 'nuxt_plugin_unsplash_b291ee2a' // Source: ../plugins/libs/unsplash (mode: 'all')
import nuxt_plugin_trackingidentify_6842db17 from 'nuxt_plugin_trackingidentify_6842db17' // Source: ../plugins/libs/tracking-identify (mode: 'client')
import nuxt_plugin_chart_46e06913 from 'nuxt_plugin_chart_46e06913' // Source: ../plugins/libs/chart (mode: 'client')
import nuxt_plugin_services_454c55d4 from 'nuxt_plugin_services_454c55d4' // Source: ../plugins/services (mode: 'all')
import nuxt_plugin_auth_4eb85d5a from 'nuxt_plugin_auth_4eb85d5a' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"","titleTemplate":function(title) {
      if (title) {
        return `${title} - EOwn Stream Studio`;
      }
      return 'EOwn Stream Studio';
    },"meta":[{"hid":"og:title","property":"og:title","content":"EOwn stream studio"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","property":"apple-mobile-web-app-title","content":"EOwn stream studio"},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"EOwn stream studio"},{"hid":"description","name":"description","content":"EOwn Stream Studio"},{"hid":"og:description","property":"og:description","content":"EOwn Stream Studio"},{"hid":"og:type","property":"og:type","content":"article"},{"hid":"og:image","property":"og:image","content":"\u002Fimages\u002Fshare-sign-up.png"},{"hid":"twitter:image","name":"twitter:image","content":"\u002Fimages\u002Fshare-sign-up.png"},{"hid":"og:image:width","property":"og:image:width","content":"600"},{"hid":"og:image:height","property":"og:image:height","content":"600"},{"hid":"twitter:description","name":"twitter:description","content":"EOwn Stream Studio"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"name":"p:domain_verify","content":"4a86c4889a1b2ee519fb8c30a4ff5211"}],"link":[{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon.png"},{"rel":"apple-touch-icon","type":"image\u002Fpng","href":"\u002Ffavicon.png"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Inter:300,400,500,700|Material+Icons|Material+Icons+Round|Material+Icons+Outlined"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Abhaya+Libre:wght@400;500;600;700;800&family=Aclonica&family=Acme&family=Advent+Pro:wght@300;400;500;600;700;800;900&family=Albert+Sans:wght@300;400;500;600;700;800;900&family=Alegreya+Sans+SC:wght@300;400;500;700;800;900&family=Alegreya+Sans:wght@300;400;500;700;800;900&family=Allerta+Stencil&family=Almendra:wght@400;700&family=Antic+Didone&family=Anton&family=Archivo+Black&family=Aref+Ruqaa:wght@400;700&family=Arimo:wght@400;500;600;700&family=Arsenal:wght@400;700&family=Arya:wght@400;700&family=Bacasime+Antique&family=Basic&family=Baskervville:ital@0;1&family=Bebas+Neue&family=Belleza&family=BioRhyme+Expanded:wght@300;400;700;800&family=Birthstone&family=Birthstone+Bounce:wght@400;500&family=Black+Han+Sans&family=Bodoni+Moda:wght@400;500;600;700;800;900&family=Cairo:wght@300;400;500;600;700;800;900&family=Carrois+Gothic+SC&family=Caveat:wght@400;500;600;700&family=Changa:wght@300;400;500;600;700;800&family=Chelsea+Market&family=Chivo:wght@300;400;500;600;700;800;900&family=Cinzel:wght@400;500;600;700;800;900&family=Comforter+Brush&family=Corinthia:wght@400;700&family=Cormorant+Garamond:wght@300;400;500;600;700&family=Cormorant+Infant:wght@300;400;500;600;700&family=Cormorant+Upright:wght@300;400;500;600;700&family=Cormorant:wght@300;400;500;600;700&family=Courier+Prime:wght@400;700&family=Cutive+Mono&family=DM+Serif+Text&family=Dancing+Script:wght@400;500;600;700&family=Delius+Unicase:wght@400;700&family=Dosis:wght@300;400;500;600;700;800&family=DotGothic16&family=Dr+Sugiyama&family=El+Messiri:wght@400;500;600;700&family=Encode+Sans+Semi+Condensed:wght@300;400;500;600;700;800;900&family=Encode+Sans:wght@300;400;500;600;700;800;900&family=Ephesis&family=Fahkwang:wght@300;400;500;600;700&family=Fauna+One&family=Federo&family=Fragment+Mono&family=Francois+One&family=Gelasio:ital,wght@0,400;0,500;0,600;0,700;1,400&family=Gentium+Plus:wght@400;700&family=Georama:wght@300;400;500;600;700;800;900&family=Gilda+Display&family=Great+Vibes&family=Gruppo&family=Gurajada&family=Holtwood+One+SC&family=Hurricane&family=IM+Fell+English+SC&family=Inconsolata:wght@300;400;500;600;700;800;900&family=Inknut+Antiqua:wght@300;400;500;600;700;800;900&family=Inter:wght@300;400;500;600;700;800;900&family=Italiana&family=Josefin+Sans:wght@300;400;500;600;700&family=Josefin+Slab:wght@300;400;500;600;700&family=Julius+Sans+One&family=Kaisei+Opti:wght@400;500;700&family=Karla:wght@300;400;500;600;700;800&family=Karma:wght@300;400;500;600;700&family=Khand:wght@300;400;500;600;700&family=Kotta+One&family=Laila:wght@300;400;500;600;700&family=League+Gothic&family=League+Script&family=Licorice&family=Liu+Jian+Mao+Cao&family=Long+Cang&family=Marmelad&family=Mate+SC&family=Maven+Pro:wght@400;500;600;700;800;900&family=Michroma&family=Monsieur+La+Doulaise&family=Montserrat+Alternates:wght@300;400;500;600;700;800;900&family=Montserrat:wght@300;400;500;600;700;800;900&family=New+Tegomin&family=Notable&family=Nothing+You+Could+Do&family=Noto+Sans:wght@300;400;500;600;700;800;900&family=Noto+Serif+Georgian:wght@300;400;500;600;700;800;900&family=Nova+Mono&family=Nunito+Sans:wght@300;400;500;600;700;800;900&family=Open+Sans:wght@300;400;500;600;700;800&family=Orbitron:wght@400;500;600;700;800;900&family=Oswald:wght@300;400;500;600;700&family=Over+the+Rainbow&family=Oxygen:wght@300;400;700&family=Passions+Conflict&family=Pattaya&family=Philosopher:wght@400;700&family=Pinyon+Script&family=Playfair+Display+SC:wght@400;700;900&family=Poppins:wght@300;400;500;600;700;800;900&family=Quantico:wght@400;700&family=Quattrocento:wght@400;700&family=Quicksand:wght@300;400;500;600;700&family=Qwigley&family=Qwitcher+Grypen:wght@400;700&family=Rajdhani:wght@300;400;500;600;700&family=Raleway:wght@300;400;500;600;700;800;900&family=Red+Hat+Mono:wght@300;400;500;600;700&family=Reem+Kufi:wght@400;500;600;700&family=Roboto+Mono:wght@300;400;500;600;700&family=Roboto+Serif:wght@300;400;500;600;700;800;900&family=Roboto:wght@300;400;500;700;900&family=Rubik+Mono+One&family=Ruthie&family=Sacramento&family=Sansita:wght@400;700;800;900&family=Shadows+Into+Light&family=Source+Code+Pro:wght@300;400;500;600;700;800;900&family=Space+Grotesk:wght@300;400;500;600;700&family=Spectral+SC:wght@300;400;500;600;700;800&family=Stoke:wght@300;400&family=Syncopate:wght@400;700&family=Tangerine:wght@400;700&family=Tenor+Sans&family=Tinos:wght@400;700&family=Titillium+Web:wght@300;400;600;700;900&family=Ubuntu+Condensed&family=Ubuntu+Mono:wght@400;700&family=Ubuntu:wght@300;400;500;700&family=Ultra&family=Vollkorn+SC:wght@400;600;700;900&family=WindSong:wght@400;500&family=Xanh+Mono&family=Yuji+Syuku&family=ZCOOL+XiaoWei&family=Zen+Antique&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"script":[{"src":"https:\u002F\u002Fjs.stripe.com\u002Fv3\u002F"},{"src":"https:\u002F\u002Fcdn.ckeditor.com\u002Fckeditor5\u002F40.0.0\u002Fsuper-build\u002Fckeditor.js"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_5a690f01 === 'function') {
    await nuxt_plugin_sentryserver_5a690f01(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_16a0c50e === 'function') {
    await nuxt_plugin_sentryclient_16a0c50e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_599beea7 === 'function') {
    await nuxt_plugin_plugin_599beea7(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_688061e5 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_688061e5(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_3b3696b6 === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_3b3696b6(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsocketio_76847fc5 === 'function') {
    await nuxt_plugin_nuxtsocketio_76847fc5(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtizitoastpluginbd4a3472_e22c11bc === 'function') {
    await nuxt_plugin_nuxtizitoastpluginbd4a3472_e22c11bc(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_0dc1f7a8 === 'function') {
    await nuxt_plugin_recaptcha_0dc1f7a8(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_514ce35a === 'function') {
    await nuxt_plugin_gtm_514ce35a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_6f764786 === 'function') {
    await nuxt_plugin_axios_6f764786(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_4c4f3619 === 'function') {
    await nuxt_plugin_workbox_4c4f3619(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_38c1542c === 'function') {
    await nuxt_plugin_metaplugin_38c1542c(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_3d68f9a0 === 'function') {
    await nuxt_plugin_iconplugin_3d68f9a0(app.context, inject)
  }

  if (typeof nuxt_plugin_http_493e3a73 === 'function') {
    await nuxt_plugin_http_493e3a73(app.context, inject)
  }

  if (typeof nuxt_plugin_bothsides_3b0578a6 === 'function') {
    await nuxt_plugin_bothsides_3b0578a6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clientonly_98019990 === 'function') {
    await nuxt_plugin_clientonly_98019990(app.context, inject)
  }

  if (typeof nuxt_plugin_index_6c6ccc7d === 'function') {
    await nuxt_plugin_index_6c6ccc7d(app.context, inject)
  }

  if (typeof nuxt_plugin_index_77bd1e08 === 'function') {
    await nuxt_plugin_index_77bd1e08(app.context, inject)
  }

  if (typeof nuxt_plugin_index_64d6d112 === 'function') {
    await nuxt_plugin_index_64d6d112(app.context, inject)
  }

  if (typeof nuxt_plugin_gtag_c19af404 === 'function') {
    await nuxt_plugin_gtag_c19af404(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_46cb9dab === 'function') {
    await nuxt_plugin_axios_46cb9dab(app.context, inject)
  }

  if (typeof nuxt_plugin_unsplash_b291ee2a === 'function') {
    await nuxt_plugin_unsplash_b291ee2a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_trackingidentify_6842db17 === 'function') {
    await nuxt_plugin_trackingidentify_6842db17(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chart_46e06913 === 'function') {
    await nuxt_plugin_chart_46e06913(app.context, inject)
  }

  if (typeof nuxt_plugin_services_454c55d4 === 'function') {
    await nuxt_plugin_services_454c55d4(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_4eb85d5a === 'function') {
    await nuxt_plugin_auth_4eb85d5a(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
